// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__KEF5S","skeleton-loading":"Skeleton_skeleton-loading__6o3VM"};